export default __webpack_public_path__ + "static/nexa-bold-c2b99812f7617bd31a220050147e457d.otf";